$(function() {
  $('.slider').slick({
    autoplay: true,
    dots: true,
    arrows: false,
  });
});

$(document).ready(function() {
  //service_slider
  $('.service_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1700,
    arrows: true,
      prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Previous"></button>',
  nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next"></button>',
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
});


////////////// shop_slider //////////////

const shopSliderEl = document.querySelector('.shop_slider');
const shopScrollbarEl = shopSliderEl
  .closest('.shop_block')
  .querySelector('.shop-scrollbar');

let shopSwiper = null;

function getSlidesOffsetAfter() {
  const w = window.innerWidth;

  if (w <= 749) {
    // ～749px
    return Math.round(w * 0.1);
  } else if (w <= 991) {
    // 750～991px（例：5%）
    //705 return Math.round(w * 0.093);
    return Math.round(w * 0.17);
  } else {
    // 992px～（例：6%）
    return Math.round(w * 0.17);
  }
}

function initShopSlider() {
  const slideCount = shopSliderEl.querySelectorAll('.swiper-slide').length;
  const isEnable = window.matchMedia('(max-width: 1199px)').matches;

  // Swiper停止
  if (!isEnable || slideCount <= 1) {
    if (shopSwiper) {
      shopSwiper.destroy(false, true);
      shopSwiper = null;
    }
    return;
  }

  const isSP = window.matchMedia('(max-width: 749px)').matches;
  const isPC = window.matchMedia('(min-width: 992px)').matches;

  let slidesPerView;
  let spaceBetween;

  if (isSP) {
    slidesPerView = 1.45;
    spaceBetween = 25;
  } else if (isPC) {
    slidesPerView = 2.8;
    spaceBetween = 10;
  } else {
    slidesPerView = 2.5;
    spaceBetween = 25;
  }

  // ％ → px 変換
  const slidesOffsetAfter = getSlidesOffsetAfter();

  // 再生成
  if (shopSwiper) {
    shopSwiper.destroy(false, true);
    shopSwiper = null;
  }

  shopSwiper = new Swiper(shopSliderEl, {
    loop: false,
    slidesPerView,
    spaceBetween,
    slidesOffsetAfter, // ← ここが％換算
    grabCursor: true,
    speed: 600,

    scrollbar: {
      el: shopScrollbarEl,
      draggable: isSP
    },

    observer: true,
    observeParents: true,
    observeSlideChildren: true
  });
}

// 初回
initShopSlider();

// breakpoint変更検知
const mqShop = window.matchMedia('(max-width: 1199px)');
mqShop.addEventListener('change', initShopSlider);

// resize対応（％再計算のため必須）
window.addEventListener('resize', initShopSlider);

////////////// shop_slider END //////////////



